// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_inputError__lHC6t {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
  margin-right: 20px;
}

.style_lds_ring__46xU5 {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
  margin-right: 20px;
}

.style_lds_ring__46xU5 div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: style_lds_ring__46xU5 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.style_lds_ring__46xU5 div:nth-child(1) {
  animation-delay: -0.45s;
}

.style_lds_ring__46xU5 div:nth-child(2) {
  animation-delay: -0.3s;
}

.style_lds_ring__46xU5 div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes style_lds_ring__46xU5 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#style_form-file-upload__EAPI9 {
  height: 16rem;
  width: 28rem;
  max-width: 100%;
  text-align: center;
  position: relative;
}

#style_input-file-upload__Hc6J9 {
  display: none;
}

#style_label-file-upload__AJnXy {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 1rem;
  border-style: dashed;
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.style_dragActive__V3j68 {
  background-color: #ffffff;
}

.style_uploadButton__2p47c {
  background-color: unset;
  box-shadow: unset;
  color: inherit;
}

.style_upload-button__TP6oH:hover {
  text-decoration-line: underline;
}

.style_dragAcrive__I1dkj {
  background-color: #ffffff;
}

.style_dragFileElement__gStV6 {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileUploadVideo/style.module.scss"],"names":[],"mappings":"AAUA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AATF;;AAeA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,2EAAA;EACA,yDAAA;AAZF;;AAeA;EACE,uBAAA;AAZF;;AAeA;EACE,sBAAA;AAZF;;AAeA;EACE,uBAAA;AAZF;;AAeA;EACE;IACE,uBAAA;EAZF;EAeA;IACE,yBAAA;EAbF;AACF;AAgBA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAiBA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;AAdF;;AAmCA;EACE,+BAAA;AAhCF;;AAmCA;EAEE,yBAAA;AAjCF;;AAqCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;AAlCF","sourcesContent":["// label {\n//     display: inline-block;\n//     background-color: indigo;\n//     color: white;\n//     padding: 0.5rem;\n//     font-family: sans-serif;\n//     border-radius: 0.3rem;\n//     cursor: pointer;\n//     margin-top: 1rem;\n// }\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n  margin-right: 20px;\n  // justify-self: flex-start;\n}\n\n//------------------------loader style\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n  margin-right: 20px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n#form-file-upload {\n  height: 16rem;\n  width: 28rem;\n  max-width: 100%;\n  text-align: center;\n  position: relative;\n}\n\n#input-file-upload {\n  display: none;\n}\n\n#label-file-upload {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-width: 2px;\n  border-radius: 1rem;\n  border-style: dashed;\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.dragActive {\n  background-color: #ffffff;\n}\n\n.uploadButton {\n  background-color: unset;\n  box-shadow: unset;\n  color: inherit;\n}\n\n// .uploadButton {\n//   cursor: pointer;\n\n//   box-sizing: border-box;\n//   display: flex;\n//   flex-direction: row;\n//   align-items: center;\n//   justify-content: center;\n//   padding: 6px 24px;\n//   width: 122px;\n//   height: 37px;\n//   background: #E30813;\n//   border-radius: 4px;\n//   color: #ffffff;\n//   margin-bottom: 40px;\n\n// }\n\n.upload-button:hover {\n  text-decoration-line: underline;\n}\n\n.dragAcrive {\n\n  background-color: #ffffff;\n\n}\n\n.dragFileElement {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1rem;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n\n\n  // .imageContainer {\n  //   width: 40%;\n  // }\n  // .uploadButton {\n  //   background-color: inherit;\n  //   color: rgba(0, 0, 0, 0.54);\n  //   margin-bottom: 0;\n  //   padding: 0;\n  //   width: auto;\n  //   font-style: normal;\n  //   font-weight: 500;\n  //   font-size: 14px;\n  //   line-height: 20px;\n  //   /* identical to box height, or 143% */\n\n  //   text-align: right;\n  // }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputError": `style_inputError__lHC6t`,
	"lds_ring": `style_lds_ring__46xU5`,
	"form-file-upload": `style_form-file-upload__EAPI9`,
	"input-file-upload": `style_input-file-upload__Hc6J9`,
	"label-file-upload": `style_label-file-upload__AJnXy`,
	"dragActive": `style_dragActive__V3j68`,
	"uploadButton": `style_uploadButton__2p47c`,
	"upload-button": `style_upload-button__TP6oH`,
	"dragAcrive": `style_dragAcrive__I1dkj`,
	"dragFileElement": `style_dragFileElement__gStV6`
};
export default ___CSS_LOADER_EXPORT___;
